/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_Workspace_DescInputs */

const en_mk_nav_workspace_desc = /** @type {(inputs: Mk_Nav_Workspace_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plans, roadmaps, tasks, and wiki.`)
};

const id_mk_nav_workspace_desc = /** @type {(inputs: Mk_Nav_Workspace_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rencana, roadmap, tugas, dan wiki.`)
};

/**
* | output |
* | --- |
* | "Plans, roadmaps, tasks, and wiki." |
*
* @param {Mk_Nav_Workspace_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_workspace_desc = /** @type {((inputs?: Mk_Nav_Workspace_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_Workspace_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_workspace_desc(inputs)
	return en_mk_nav_workspace_desc(inputs)
});